import React, { useState, useMemo, useEffect, forwardRef, useRef } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableVirtuoso } from "react-virtuoso";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import emptyFile from "../../../assets/images/lottie/empty_file.json";
import {
  formatNumberToIndianNationalSystem,
  formatToRupees,
} from "../../../utils/utils";

import {
  DownloadLink,
  Dropdown,
  FilterImage,
  BoxHeading,
  ContentRow,
  FilterDiv,
  HeaderRow,
  InputDiv,
  MaterialTable,
  MaterialTableContainer,
  Option,
  SearchfilterDiv,
  TableWrapper,
  Download,
} from "../../../components/GmcDashbaord/styles";
import { Ptag } from "../../../components/fonts";
import DownloadIcon from "../../../assets/svgs/download_white.svg";
import FilterIcon from "../../../assets/svgs/filter.svg";
import { FlexProductList, IndividualList, MessageDiv } from "./styles";
import { FLEX_PRODUCTS } from "../../../constants/businessConstant";
import { theme } from "../../../theme";
import { Chip, LoaderDots } from "../../../components";
import http from "../../../services/httpService";
import Icons from "../../../components/business/icons";
import { boolean } from "yup";
import Lottie from "react-lottie";

const FlexMisTable = ({ uhidEsixt }) => {
  const [sumInsured, setSumInsured] = useState("");
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [misTbaleData, setMisTableData] = useState([]);
  const [overallData, setOverallData] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [currentProductDetail, setCurrentProductDetail] = useState();
  const timerRef = useRef(null);
  const [currentProduct, setCurrentProduct] = useState(
    JSON.parse(localStorage.getItem("flex_product_priority_list"))[0]
  );
  const attributes = JSON.parse(localStorage.getItem("gmc_details"));
  const history = useHistory();
  useEffect(() => {
    getModernFlex();
  }, []);

  useEffect(() => {
    window.addEventListener("error", (e) => {
      console.log(e.message);
      if (
        e.message ===
        "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  const VirtuosoTableComponents = {
    Scroller: forwardRef((props, ref) => (
      <TableContainer {...props} ref={ref} sx={MaterialTableContainer} />
    )),
    Table: (props) => <Table {...props} sx={MaterialTable} />,
    TableHead,
    TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
    TableBody: forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
  };

  function fixedHeaderContent() {
    return (
      <TableRow>
        {columns.map((column, index) => (
          <TableCell
            key={index}
            variant="head"
            align="center"
            style={{ width: column.width }}
            sx={HeaderRow}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    );
  }
  function isActivatedFlexEmployee(status) {
    const show = status.join().includes("ACTIVATED");
    return show;
  }

  function convertToMixedCase(str) {
    let words = str.split(" ");
    if (words.length != 2) {
      return str;
    }

    let firstWord = words[0].toUpperCase();

    let secondWord = words[1].toLowerCase();
    secondWord = secondWord.charAt(0).toUpperCase() + secondWord.slice(1);

    return firstWord + " " + secondWord;
  }

  const getFlexProductStatus = (status) => {
    let JSX = [];
    status.forEach((value, index) => {
      const updatedVal = convertToMixedCase(value);
      if (updatedVal.toUpperCase().includes("PENDING")) {
        JSX.push(<Chip background="#F7CB59" text={updatedVal} size="small" />);
      } else if (updatedVal.toUpperCase().includes("ACTIVATED")) {
        JSX.push(<Chip background="#81C14B" text={updatedVal} />);
      } else if (updatedVal.toUpperCase().includes("DELET")) {
        JSX.push(<Chip background="#FF9446" text={updatedVal} />);
      } else if (updatedVal.toUpperCase().includes("STOPPED")) {
        JSX.push(<Chip background="#F27576" text={updatedVal} />);
      }
    });
    return (
      <section style={{ gap: "0.6rem", display: "flex" }}>
        {JSX.map((el) => el)}
      </section>
    );
  };

  function jsxRow(column, index, row) {
    let JSX;
    const columnWidth = column.width + "px";
    switch (column.label) {
      case "E-Card":
        JSX = (
          <TableCell
            align="center"
            style={{
              width: columnWidth,
            }}
            sx={ContentRow}
            key={index}
            f
          >
            {isActivatedFlexEmployee(row.Status) ? (
              <DownloadLink onClick={() => navigateToEcardPreview(row)}>
                View
              </DownloadLink>
            ) : (
              <Ptag
                textAlign="center"
                fontSize="14px"
                lineHeight={1.3}
                fontWeight="500"
              >
                -
              </Ptag>
            )}
          </TableCell>
        );
        break;
      case "Status":
        JSX = (
          <TableCell sx={ContentRow}>
            {getFlexProductStatus(row.Status)}
          </TableCell>
        );
        break;
      default: {
        const targetLabel = "Sum Insured";
        const isSumInsuredColumn = column.label.includes(targetLabel);

        let formattedValue;

        if (isSumInsuredColumn) {
          const cellValue = row[column.label]
            ? row[column.label].toString()
            : "";

          if (cellValue) {
            formattedValue = formatToRupees(cellValue);
          } else {
            formattedValue = "-";
          }
        } else {
          formattedValue = row[column.label] || "-";
        }
        JSX = (
          <TableCell align="center" sx={ContentRow} key={index}>
            {formattedValue || "_"}
          </TableCell>
        );
        break;
      }
    }
    return JSX;
  }

  function rowContent(_index, row) {
    let JSX;
    try {
      JSX = <>{columns.map((column, index) => jsxRow(column, index, row))}</>;
    } catch (error) {}
    return JSX;
  }

  const navigateToEcardPreview = (row) => {
    history.push({
      pathname: "/business/e-card-preview",
      state: {
        employeeId: row["System Employee Id"],
        productType: currentProduct,
      },
    });
    // navigate("/e-card-preview", {state:{employeeId:row.employee_id ,productType: currentProduct}})
  };
  const getModernFlex = async (searchString, isFilter) => {
    // setIsLoading(true);
    let localToken = -1;
    let error = false;
    while (localToken !== 0 && localToken !== null && error === false) {
      const payload = {
        token: localToken,
        offset: 1000,
        // mis_flag: true,
      };
      if (searchString) payload.search_string = searchString;
      if (isFilter) {
        payload.status_filter = isFilter.display_policy_status;
        payload.status_filter_userplan_id = isFilter.userplanId;
      }
      try {
        let { data } = await http.get(
          "business/get_employee_detail_for_group_products/",
          {
            params: payload,
          }
        );
        if (data && data.mis_employee_data) {
          setOverallData((prevData) => {
            if (!prevData) {
              return data.mis_employee_data;
            }
            return [...prevData, ...data.mis_employee_data];
          });
        } else {
          setOverallData([]);
        }
        if (localToken === -1) {
          const status_width = (data.headers_data.length - 4) / 2;
          const col_name = data.headers_data;
          const newColm = col_name.map((val, index) => {
            let local_width = 150;
            if (val == "Status") {
              local_width = status_width * 150;
            }
            return { width: local_width, label: val };
          });
          setColumns(newColm);
        }
        localToken = data.end_index;
      } catch (e) {
        error = true;
        console.log(e);
      } finally {
        if (!searchString && !isFilter) setIsLoading(false);
      }
    }
  };

  const downloadExcel = async () => {
    let { data } = await http.post(
      "business/download_mis_or_data_collection/",
      {},
      { responseType: "blob" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "employee_data.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };
  const getCurrentEmployees = () => {
    let data = overallData.find((innerList) => innerList[0] === currentProduct);
    return data && data[1];
  };

  const handleSearchChange = (e) => {
    const newSearchString = e.target.value;
    setSearchString(newSearchString);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Set a new timer to call the API after 2 seconds
    timerRef.current = setTimeout(async () => {
      setOverallData([]);
      await getModernFlex(newSearchString);
    }, 500);
  };

  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "44px",
          }}
        >
          <LoaderDots />
        </div>
      ) : (
        <>
          {uhidEsixt ? (
            <>
              <BoxHeading
                style={{ marginTop: "3rem", alignItems: "flex-start" }}
              >
                <Ptag fontSize="24px" fontWeight="700">
                  Manage Employees
                </Ptag>
                <Download onClick={downloadExcel}>
                  <img
                    src={DownloadIcon}
                    width="18px"
                    height="18px"
                    style={{ marginRight: 8 }}
                  />
                  <Ptag
                    fontSize="14px"
                    fontWeight="600"
                    color="#FFFFFF"
                    lineHeight="24px"
                    letterSpacing="0.5px"
                  >
                    Download Employee Data
                  </Ptag>
                </Download>
              </BoxHeading>
              <SearchfilterDiv>
                <InputDiv>
                  <input
                    value={searchString}
                    onChange={handleSearchChange}
                    className="input-elevated"
                    type="text"
                    placeholder="Search with Employee ID or Name"
                  />
                </InputDiv>
                <div style={{ display: "flex" }}>
                  {/* <FilterDiv>
            <FilterImage src={FilterIcon} />
            <Dropdown color="#fff">
              <Option value="" default disabled selected hidden>
                Filter
              </Option>
              <Option value={"none"}>{"None"}</Option>
            </Dropdown>
            <div style={{ marginRight: "12px" }}>
              <Icons icon={"chevron_down"} fill="#ffffff" />
            </div>
          </FilterDiv> */}
                </div>
              </SearchfilterDiv>
              {/* {flexProductList()} */}
              <TableWrapper>
                <TableVirtuoso
                  data={overallData}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </TableWrapper>
            </>
          ) : (
            <BoxHeading style={{ marginTop: "3rem", display: "block" }}>
              <Ptag fontSize="24px" fontWeight="700" marginBottom="16px">
                Manage Employees
              </Ptag>
              <MessageDiv>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: emptyFile,
                      rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                      },
                    }}
                    height={120}
                    width={120}
                    style={{ opacity: "1" }}
                    isClickToPauseDisabled
                  />
                  <Ptag fontSize="18px" fontWeight="600" lineHeight="20">
                    Employee Data Unavailable
                  </Ptag>
                </div>
              </MessageDiv>
            </BoxHeading>
          )}
        </>
      )}
    </>
  );
};

export default FlexMisTable;
